<mat-card [class.left]="side=='left'" [class.right]="side=='right'">
    <mat-card-header class="time"></mat-card-header>
    <mat-card-content>
        <ng-content></ng-content>
    </mat-card-content>
</mat-card>